export default "__VITE_ASSET__BGJev$_p__"